import React, { useEffect, useState } from 'react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { oneDark } from 'react-syntax-highlighter/dist/esm/styles/prism';
import styled from '@emotion/styled';
import axios from 'axios';
import { CircularProgress } from '@mui/material';

type XmlPreviewProps = {
  url: string;
  language?: string;
};

export const STRING_PREVIEW_TYPES = ['txt', 'xml', 'csv', 'json', 'itt', 'scc', 'srt', 'vtt'];

const StringPreview: React.FC<XmlPreviewProps> = ({ url, language }) => {
	const [xmlString, setXmlString] = React.useState<string | null>('');
  const [error, setError] = useState<string | null>(null);

  const getData = async () => {
    if (url) {
      try {
      const response = await axios.get(url, { responseType: 'text' })
      let data = response.data;

      if (language === 'json') {
        data = JSON.stringify(JSON.parse(data), null, 2);
      }

      setXmlString(data);
      } catch (err) {
        console.error(err);
        setError('Error fetching data');
      }
    }
  }

  useEffect(() => {
    getData();
  }, [url]);

  return (
    <Container>
      {error ? (
        <ErrorMessage>{error}</ErrorMessage>
      ) : xmlString ? (
        <SyntaxHighlighter language={language} style={oneDark} wrapLongLines>
          {xmlString}
        </SyntaxHighlighter>
      ) : (
        <Loader />
      )}
    </Container>
  );
};

export default StringPreview;

const Container = styled.div`
  width: 100%;
  max-height: 50vh;
  overflow-y: auto;
  border: 1px solid ${({ theme }) => theme.palette.divider};
  border-radius: 4px;
  padding: 16px;
  background-color: ${({ theme }) => theme.palette.background.paper};

  &::-webkit-scrollbar-corner {
    background: transparent;
  }

  pre {
    overflow: unset !important;
    width: fit-content;
    min-width: 100%;
  }
`;

const Loader = styled(CircularProgress)`
  display: block;
  margin: 0 auto;
`;

const ErrorMessage = styled.div`
  text-align: center;
  color: ${({ theme }) => theme.palette.error.main};
  font-size: 1rem;
  padding: 20px;
`;